(function() {
    'use strict';

    angular
        .module('doctorclubboApp')
        .controller('GcSystemDeleteController',GcSystemDeleteController);

    GcSystemDeleteController.$inject = ['$uibModalInstance', 'entity', 'GcSystem'];

    function GcSystemDeleteController($uibModalInstance, entity, GcSystem) {
        var vm = this;

        vm.gcSystem = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            GcSystem.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
